import { Component, Input, inject, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { ShoppingCartItem } from '../shopping-cart.types';
import { CIPXCartSummaryComponent } from '../cart-summary/cart-summary.component';

@Component({
  selector: 'cipx-shopping-cart-confirmation',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    CIPXCartSummaryComponent
  ],
  template: `
    <div class="flex flex-col">
      <div class="flex flex-col items-center mt-8">
        <!-- Confirmation Icon and Message -->
        <div class="flex flex-row w-full gap-4 items-center p-2">
          <img src="assets/icons/check.svg" alt="Checkmark" class="h-25 w-15">
          <div class="flex flex-col justify-center">
            <!-- <div class="text-gray-500 text-md sm:text-sm">
              Order #{{ orderNumber || 'PENDING' }}
            </div> -->
            <h1 class="text-3xl sm:text-xl font-bold">Purchase Complete!</h1>
          </div>
        </div>

        <!-- Purchase Details Card -->
        <mat-card class="w-full max-w-2xl border border-gray-200 shadow-sm mt-4">
          <mat-card-header>
            <mat-card-title class="text-lg font-semibold">Your purchase is confirmed</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p class="my-2">
              Thank you for your purchase. Your order has been successfully processed and your bonds are being prepared.
            </p>
            <p class="my-2">
              You will receive a confirmation email shortly with your order details and bond documents. We recommend that you add
              <a href="mailto:service@suretybonds.com"
                 class="text-primary hover:underline">
                service&#64;suretybondsdirect.com
              </a>
              to your address book to ensure that you receive your documents as quickly as possible.
            </p>
          </mat-card-content>
        </mat-card>

        <!-- Order Summary -->
        <div class="w-full max-w-2xl mt-4">
          <cipx-cart-summary
            [items]="items"
            title="Order Details"
            totalLabel="Total Paid"
            [showItemDetails]="true"
            [showItemCount]="false">
          </cipx-cart-summary>
        </div>

        <!-- Actions -->
        <div class="flex flex-row gap-2 items-center justify-center mt-6">
          <div class="flex">
            <!-- <button mat-flat-button color="primary" class="border-2 rounded-r-none" (click)="onPurchaseAnother()">
              Purchase Another
            </button>
            <button
              mat-flat-button
              color="primary"
              class="border-2 border-l-0 rounded-l-none min-w-0 px-2"
              [matMenuTriggerFor]="purchaseAnotherMenu"
              aria-label="More purchase options">
              <mat-icon>expand_more</mat-icon>
            </button>
          </div>

          <mat-menu #purchaseAnotherMenu="matMenu">
            <button mat-menu-item (click)="onPurchaseAnotherSimilar()">
              <mat-icon>shopping_cart</mat-icon>
              <span>Purchase Similar Bond</span>
            </button>
            <button mat-menu-item (click)="onRequestQuote()">
              <mat-icon>description</mat-icon>
              <span>Request New Quote</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onPurchaseAnother()">
              <mat-icon>add</mat-icon>
              <span>Browse All Bonds</span>
            </button>
          </mat-menu> -->

          <button mat-flat-button color="accent" (click)="onViewBonds()">
            Home
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }

    .h-25 {
      height: 6.25rem;
    }

    .w-15 {
      width: 3.75rem;
    }
  `]
})
export class CIPXShoppingCartConfirmationComponent {
  @Input() items: ShoppingCartItem<any>[] = [];
  @Input() orderNumber: string | null = null;

  @Output() purchaseAnother = new EventEmitter<void>();
  @Output() purchaseAnotherSimilar = new EventEmitter<void>();
  @Output() requestQuote = new EventEmitter<void>();
  @Output() viewBonds = new EventEmitter<void>();

  onPurchaseAnother() {
    this.purchaseAnother.emit();
  }

  onPurchaseAnotherSimilar() {
    this.purchaseAnotherSimilar.emit();
  }

  onRequestQuote() {
    this.requestQuote.emit();
  }

  onViewBonds() {
    this.viewBonds.emit();
  }
}
